import { render } from "./UserDetailArticle.vue?vue&type=template&id=16b948e4&scoped=true"
import script from "./UserDetailArticle.vue?vue&type=script&lang=js"
export * from "./UserDetailArticle.vue?vue&type=script&lang=js"

import "./UserDetailArticle.vue?vue&type=style&index=0&id=16b948e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b948e4"]])

export default __exports__